// Package Imports
import React from 'react';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';

// Project Imports
import { DateInputProps } from 'components/date/type';

const { RangePicker } = DatePicker;

const RangeInput = ({
  label,
  name,
  style,
  disabled,
  required,
  message,
  disabledDate,
  showTime,
  disabledTime,
  rules,
}: DateInputProps) => (
  <div
    className={
      disabled
        ? 'floating-disabled relative custom-border'
        : 'relative custom-border'
    }
  >
    <label className="floating-label">
      {label} {required ? <span className="a8-error">*</span> : null}
    </label>
    <Form.Item
      style={style}
      rules={[
        { required, message },
        () => ({
          validator(_, value) {
            if (!value || value.length < 2) return Promise.resolve();
            const [start, end] = value;
            if (start && end) {
              if (showTime) {
                if (dayjs(start).isSame(dayjs(end), 'second')) {
                  return Promise.reject(
                    new Error(
                      'End date/time cannot be the same as start date/time'
                    )
                  );
                }
              } else if (dayjs(start).isSame(dayjs(end), 'day')) {
                return Promise.reject(
                  new Error('End date cannot be the same as start date')
                );
              }
            }
            return Promise.resolve();
          },
        }),
        rules,
      ]}
      name={typeof name === 'string' ? [name] : name}
    >
      <RangePicker
        disabled={disabled}
        className="py-3 "
        disabledDate={disabledDate}
        showTime={showTime === true}
        disabledTime={disabledTime}
        cellRender={(current, info) => {
          if (info.type === 'date') {
            const dayWithLeadingZero = String((current as any).date()).padStart(
              2,
              '0'
            );

            return (
              <div className="ant-picker-cell-inner">{dayWithLeadingZero}</div>
            );
          }
          return info.originNode; // month year
        }}
      />
    </Form.Item>
  </div>
);

export default RangeInput;
